import EditableTable from "../../components/table/EditableTable";
import { useCallback, useMemo   } from "react";
import { useTranslation } from "react-i18next";
import {
    TEXT_FIELD_TYPE,
    NUMERIC_FIELD_TYPE,
    DATE_FIELD_TYPE
} from "../../helpers/constants";
import TableService from "../../services/tableService";
import { IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DateService from "../../services/dateService";
import RemoveIcon from "@mui/icons-material/Remove";
import { roundToDecimalPlaces } from "../../helpers/methods";

export const TABLE_NAME = "agrement_overdue_payments_table";
import { UPPERCASE_ALPHABET } from "../../helpers/constants";

export const useAgreementOverduePaymentTableFieldsConfig = () => {
    const { t } = useTranslation();

    return [
        {
            name: "",
            label: "",
            dataType: null,
            getValueCallback: (rowData, idx, payments, onSplitPayment, onDeletePayment) => (
            <>
                {idx > 0 && !rowData.agreement_payment_is_final_settlement && !rowData.is_paid && !payments[idx-1]?.is_paid && rowData.paid_amount == 0 && (UPPERCASE_ALPHABET.split("").filter(ch=>ch !== "A").some(
                  ch=>rowData.tranche_name.split(" ")?.[1].split("").includes(ch)
                )) && <IconButton
                    color={"primary"}
                    onClick={(e) => onDeletePayment(idx)}
                >
                    <RemoveIcon />
                </IconButton>}
                {!rowData.is_paid && !rowData.agreement_payment_is_final_settlement && rowData.remaining_amount > 0 && rowData.agreement_payment_amount > 0 && <IconButton
                    color={"primary"}
                    onClick={(e) => onSplitPayment(idx)}
                >
                    <AddIcon />
                </IconButton>}
            </>

            ),
            editable: false
        },
        {
            name: "tranche_name",
            getValueCallback: (rowData) => <span style={{color: rowData.is_overdue_payment ? 'red' : null, paddingInline: "30px"}}>{rowData.tranche_name}</span>,
            label: t("agreements.payment.payment"),
            dataType: null,
            editable: false,
        },
        {
            name: "due_date",
            getValueCallback: (rowData) => rowData.due_date,
            getAlert: (rowData) => rowData.invalid_due_date === true,
            getEditable: (rowData) => !rowData.is_paid,
            label: t("agreements.payment.dueDate"),
            dataType: DATE_FIELD_TYPE,
            editable: true,
        },
        {
            name: "agreement_payment_amount",
            getValueCallback: (rowData) => rowData.agreement_payment_amount,
            getAlert: (rowData) => rowData.invalid_agreement_payment_amount === true,
            getEditable: (rowData) => !rowData.is_paid && !rowData.agreement_payment_is_final_settlement,
            label: t("agreements.payment.tracheAmount"),
            dataType: NUMERIC_FIELD_TYPE,
            editable: true,
        },
        {
            name: "",
            getValueCallback: (rowData, idx, payments) => {
              return (
                roundToDecimalPlaces(rowData.agreement_payment_parent_amount - payments.filter(p=> p.agreement_payment_parent_id === rowData.agreement_payment_parent_id).reduce((sum, curr) => roundToDecimalPlaces(sum + roundToDecimalPlaces(parseFloat(curr.agreement_payment_amount || 0), 2),2), 0), 2)
              )
            },
            label: t("agreements.payment.remaningToSettlement"),
            dataType: null,
            editable: false,
        },
        {
            name: "paid_amount",
            getValueCallback: (rowData) => rowData.paid_amount,
            label: t("agreements.payment.amountPaid"),
            dataType: NUMERIC_FIELD_TYPE,
            editable: false,
        },
        {
            name: "remaining_amount",
            getValueCallback: (rowData) => rowData.remaining_amount,
            label: t("agreements.payment.amountRemaining"),
            dataType: NUMERIC_FIELD_TYPE,
            editable: false,
        },
        // {
        //     name: "agreement_payment_parent_amount",
        //     getValueCallback: (rowData) => rowData.agreement_payment_parent_amount,
        //     label: t("agreements.payment.parentTracheAmount"),
        //     dataType: NUMERIC_FIELD_TYPE,
        //     editable: false,
        // },
    ];
};



function AgreementPaymentSchedule(props) {
    const { paymentsLocal, setPaymentsLocal } = props
    const TABLE_CONFIG = useAgreementOverduePaymentTableFieldsConfig()
    const onChangeTableDataLocal = useCallback(
      (name, value, idx) => {
      setPaymentsLocal((prev) => {
            let tempDataLocal = [...prev];
            let payment = { ...tempDataLocal[idx] };

            if (name == 'agreement_payment_amount') {
              // payment[name] = parseFloat(value);
              payment[name] = value
              payment.remaining_amount = payment.agreement_payment_amount - payment.paid_amount
            } else if (name == 'due_date') {
              payment[name] = DateService.getIsoDateFromDatetime(value)
            }
            tempDataLocal[idx] = { ...payment };
            return tempDataLocal;
        });
      },
      [setPaymentsLocal]
  );

  const onSplitPayment = useCallback(
      (idx) => {
      setPaymentsLocal((prev) => {
            let tempDataLocal = [...prev];
            let payment = { ...tempDataLocal[idx] };
            const todayDate = new Date()
            if (!payment.due_date || new Date(payment.due_date) < todayDate) {
              payment.due_date = DateService.getIsoDateFromDatetime(todayDate)
            }
            
            let firstPayment = null
            let secondPayment = null
            if (payment.paid_amount > 0) {
              firstPayment = {...payment}
              firstPayment.agreement_payment_amount = payment.paid_amount
              firstPayment.remaining_amount = 0
              firstPayment.is_paid = true
              
              secondPayment = {...payment}
              secondPayment.agreement_payment_amount = payment.agreement_payment_amount - firstPayment.agreement_payment_amount
              secondPayment.paid_amount = 0
              secondPayment.remaining_amount = secondPayment.agreement_payment_amount - secondPayment.paid_amount

            } else {
              firstPayment = {...payment} 
              secondPayment = {...payment}
              secondPayment.agreement_payment_amount = 0
              secondPayment.paid_amount = 0
              secondPayment.remaining_amount = 0

            }
            tempDataLocal.splice(idx, 1, firstPayment, secondPayment)
            // update payment_name
            let letters = UPPERCASE_ALPHABET
            let letterIdx = 0
            for (let tempPayment of tempDataLocal) {
              if (tempPayment.agreement_payment_parent_id == payment.agreement_payment_parent_id) {
                tempPayment.tranche_name = payment.agreement_payment_parent_name + letters[letterIdx]
                letterIdx++
              }
            }
            
            // [idx] = { ...payment };
            return tempDataLocal;
        });
      },
      [setPaymentsLocal]
  );

  const onDeletePayment = useCallback(
      (idx) => {
      setPaymentsLocal((prev) => {
            let tempDataLocal = [...prev];
            
            let paymentToDelete = { ...tempDataLocal[idx] }; 
            let previousPaymentFromSameParent = { ...tempDataLocal[idx-1] };
          
            previousPaymentFromSameParent.agreement_payment_amount = previousPaymentFromSameParent.agreement_payment_amount + paymentToDelete.agreement_payment_amount
            previousPaymentFromSameParent.remaining_amount = previousPaymentFromSameParent.agreement_payment_amount - previousPaymentFromSameParent.paid_amount

            tempDataLocal[idx-1] = { ...previousPaymentFromSameParent };
            tempDataLocal.splice(idx, 1)

            // update payment_name
            let paymentsFromSameParent = tempDataLocal.filter(payment=>payment.agreement_payment_parent_id === paymentToDelete.agreement_payment_parent_id)
            if (paymentsFromSameParent.length === 1) {
              tempDataLocal[idx-1].tranche_name = previousPaymentFromSameParent.agreement_payment_parent_name
            } else {
              let letters = UPPERCASE_ALPHABET
              let letterIdx = 0
              for (let tempPayment of paymentsFromSameParent) {
                if (tempPayment.agreement_payment_parent_id == previousPaymentFromSameParent.agreement_payment_parent_id) {
                  tempPayment.tranche_name = previousPaymentFromSameParent.agreement_payment_parent_name + letters[letterIdx]
                  letterIdx++
                }
              }
            }
            return tempDataLocal;
        });
      },
      [setPaymentsLocal]
  );

  const editableData = useMemo(
    () =>
      paymentsLocal
        ? TableService.getFieldsConfigForEditableTable(
          TABLE_CONFIG,
          paymentsLocal,
          {},
          paymentsLocal,
          onSplitPayment,
          onDeletePayment
        )
        : [],
    [paymentsLocal, TABLE_CONFIG]
  );
  return (
    <EditableTable
        data={editableData}
        isLoading={false}
        showTableLoader={false}
        readOnly={false}
        editable={true}
        showCheckbox={false}
        showCleanFilterIcon={false}
        onDataChange={onChangeTableDataLocal}
        onBlur={() => { }}
        style={{
        maxHeight: "100vh",
        }}
        tableConfig={TABLE_CONFIG}
        showContextMenu={false}
        withParamsComparision={false}
        showExportToFileButton={false}
        enableExport={false}
    />
  )
}

export default AgreementPaymentSchedule